import '../../images/admin/content/ico-billing.svg';

window.addEventListener('DOMContentLoaded', function () {
    const page = document.getElementById('js-billings-list');
    if (!page) return;

    $('#btn_filters_clear').on('click', function (e) {
        e.preventDefault();
        const form = $('#frm_list_filter');

        form.find("select[name='search_form[billing_month]']").val('');
        form.find("select[name='search_form[sort]']").val('1');
    });
});
